<template>
    <div
        ref="newAccountConnectionPopup"
        class="fixed w-screen h-screen top-0 left-0 bg-black/60 z-[200] flex items-center justify-center cursor-pointer"
        @keydown.esc="hide"
        @click.self.exact="hide"
    >
        <div class="rounded bg-base-100 shadow-lg cursor-auto flex flex-col w-[30em] p-3 z-[201]">
            <div class="text-xl mb-6">Ny bankkonto for konto {{ bookkeepingAccount.accountNo }}</div>
            <bookkeeping-account-bank-account-editor
                class="flex flex-col"
                :bookkeeping-account="bookkeepingAccount"
                @save="save"
                @cancel="hide"
            />
        </div>
    </div>
</template>

<script setup lang="ts">

import hotkeys from 'hotkeys-js'
import {ref} from 'vue'
import BookkeepingAccountBankAccountEditor from '@/bank/BookkeepingAccountBankAccountEditor.vue'

const newAccountConnectionPopup = ref<HTMLElement | null>(null)
const emit = defineEmits(['close'])
const hide = () => {
    emit('close')
}

defineProps({
    bookkeepingAccount: {
        type: Object as () => { accountNo: string, displayName: string, subKey: string | null },
        required: true
    }
})

hotkeys('esc', hide)
const save = () => {
    hide()
}
</script>

<style scoped></style>